// extracted by mini-css-extract-plugin
export default {"similarityAlert":"jpfaQTBFK8AFBZsFOIau"};